// Get value from query URL
export const getValueFromQuery = (str, value) => {
    return str
        .split(`${value}=`)
        .pop()
        .split('&')[0];
};
